import * as constants from '../constants';
import { Message } from '../models/'; 

export interface EditMessageRequest {
  type: constants.EDIT_MESSAGE_REQUEST;
  message: Message;
}

export interface EditMessageSuccess {
  message: Message;
  type: constants.EDIT_MESSAGE_SUCCESS;
}

export interface EditMessageFailure {
  type: constants.EDIT_MESSAGE_FAILURE;
  error: string;
}

export interface ShowEditMessagesView {
  type: constants.SHOW_EDIT_MESSAGES_VIEW;
}


export interface HideEditMessagesView {
  type: constants.HIDE_EDIT_MESSAGES_VIEW;
}

export const editMessageRequest = (message: Message): EditMessageRequest => {
  return {
    message,
    type: constants.EDIT_MESSAGE_REQUEST,
  };
};

export const editMessageSuccess = (message: Message): EditMessageSuccess => {
  return {
    message,
    type: constants.EDIT_MESSAGE_SUCCESS,
  };
};

export const editMessageFailure = (error: string): EditMessageFailure => {
  return {
    error,
    type: constants.EDIT_MESSAGE_FAILURE,
  };
};

export const showEditMessagesView = (): ShowEditMessagesView => {
  return {
    type: constants.SHOW_EDIT_MESSAGES_VIEW,
  };
};

export const hideEditMessagesView = (): HideEditMessagesView => {
  return {
    type: constants.HIDE_EDIT_MESSAGES_VIEW,
  };
};







// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/editMessage.ts